import AgencyUser from "./AgencyUser.js";
import DirectorRole from "./role/DirectorRole.js";

/**
 * A user who owns an agency.
 */
export default class AgencyDirector extends AgencyUser {
	isAgencyDirector() {
		return true;
	}

	getRoles() {
		// TODO: This method and its class will be deleted by
		// FTGP-5715
		return [
			new DirectorRole({
				agencyId: this.getAgencyId(),
				companyIds: this.getCompanyIds(),
			}),
		];
	}

	canUpgradeCompany(company) {
		return this.getAgencyId() === company.getAgencyId();
	}

	_defaultTypeOfUser() {
		return "AgencyDirector";
	}

	static possibleTypes() {
		return ["AgencyDirector"];
	}
}
